<template>
	<div class="personHome ">
		<!-- 左侧产品列表 -->
		<div class="psLeftContent d-flex f-wrap j-sb">
			<!-- 我的产品 -->
			<div class="item w100">
				<div class="text bd10 p3">
					<div class="sTitle d-flex a-center j-sb">
						 <h3 class="font20">{{$t('adminMenu.product')}}</h3>
						 <a class="link font-light pointer" @click="goToPage('/myProduct')">{{$t('show.more')}} &gt;</a>
					</div>
					<div class="table font-light line-mn">
						<dl>
							<dt class="d-flex">
								<span>{{$t('admin.productName')}}</span>
								<span>{{$t('admin.productType')}}</span>
								<!-- <span>{{$t('admin.purchasingDate')}}</span>
								<span>{{$t('admin.versionNo')}}</span> -->
								<span class="tcenter">{{$t('admin.handle')}}</span>
							</dt>
							<dd class="d-flex" v-for="(item, index) in member.productList" :key="index">
								<span v-if="item.isIpProject" @click="goToPage('/ipProductDetail?id='+item.id)" class="nowrap2"><a class="link pointer" :title="item.productName">{{item.productName}}</a></span>
								<span v-else @click="goToPage('/productDirectory?productId='+item.id)" class="nowrap2"><a class="link pointer" :title="item.productName">{{item.productName}}</a></span>
								<span>{{item.productType}}</span>
								<span class="cor265 pointer underline d-flex tcenter j-center a-center">
									<a v-if="item.isIpProject" href="javascript:;" @click="goToPage('/ipProductDetail?id='+item.id)" class="d"></a>
									<a v-else href="javascript:;" @click="goToPage('/productDirectory?productId='+item.id)" class="d"></a>
								</span>
							</dd>
						</dl>
					</div>
				</div>
			</div>
			<!-- 下载记录 -->
			<div class="item ">
				<div class="text bd10 p3">
					<div class="sTitle d-flex a-center j-sb">
						 <h3 class="font20">{{$t('adminMenu.download')}}</h3>
						 <a class="link font-light pointer" @click="goToPage('/downloadHistory')">{{$t('show.more')}} &gt;</a>
					</div>
					<div class="table history font-light line-mn">
						<dl>
							<dd class="d-flex" v-for="(item, index) in member.downLogList" :key="index">
								<span class="nowrap1"><a class="link pointer" :title="item.title">{{item.title}}</a></span>
								<span>{{item.createTime}}</span>
							</dd>
						</dl>
					</div>
				</div>
			</div>
		</div>
		
		<!-- 右侧引导 -->
		<div class="rightGuide bd10">
			<div class="gList">
				<div class="sTitle d-flex a-center j-sb">
					 <h3 class="font20">{{$t('admin.doyouwant')}}</h3>
				</div>
				<ul class="d-flex f-wrap">
					<li @click="goToPage('/myProduct')">
						<div class="text pointer d-flex f-colu j-sb bd10 p3">
							<figure><img src="@/assets/Icons/handleIcon1.png" alt=""></figure>
							<p class="font18 line-sm">
								<span class="font-light font16 d-block">{{$t('admin.iWantChoose')}}</span>
								{{$t('admin.productsOfInterest')}}
							</p>
						</div>
					</li>
					<li @click="goToPage('/changePassword')">
						<div class="text pointer d-flex f-colu j-sb bd10 p3">
							<figure><img src="@/assets/Icons/handleIcon2.png" alt=""></figure>
							<p class="font18 line-sm"> 
								<span class="font-light font16 d-block">{{$t('admin.iWantToModify')}}</span>
								{{$t('admin.currentPassword')}}
							</p>
						</div>
					</li>
					<li @click="goToPage('/downloadHistory')">
						<div class="text pointer d-flex f-colu j-sb bd10 p3">
							<figure><img src="@/assets/Icons/handleIcon3.png" alt=""></figure>
							<p class="font18 line-sm"> 
								<span class="font-light font16 d-block">{{$t('admin.iWantToView')}}</span>
								{{$t('admin.myDownloadHistory')}}
							</p>
						</div>
					</li>
					<!-- <li @click="goToPage('/enterHistory')">
						<div class="text pointer d-flex f-colu j-sb bd10 p3">
							<figure><img src="@/assets/Icons/handleIcon4.png" alt=""></figure>
							<p class="font18 line-sm"> 
								<span class="font-light font16 d-block">{{$t('admin.iWantToView')}}</span>
								{{$t('admin.myRegistrationRecords')}}
							</p>
						</div>
					</li> -->
					<li @click="goToPage('/problemFeedback')">
						<div class="text pointer d-flex f-colu j-sb bd10 p3">
							<figure><img src="@/assets/Icons/handleIcon5.png" alt=""></figure>
							<p class="font18 line-sm"> 
								<span class="font-light font16 d-block">{{$t('admin.iWantToView')}}</span>
								{{$t('admin.isThereAnyFeedbackOnMyWorkOrder')}}
							</p>
						</div>
					</li>
					<li @click="goToPage('/ipProduct')">
						<div class="text pointer d-flex f-colu j-sb bd10 p3">
							<figure><img src="@/assets/Icons/handleIcon6.png" alt=""></figure>
							<p class="font18 line-sm"> 
								<span class="font-light font16 d-block">{{$t('admin.iWantToView')}}</span>
								{{$t('admin.myIPProductProgress')}}
							</p>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
export default {
  name: 'AdminHome',
  components: {
    
  },
  data() {
    return {
		// 主页信息
		member: {}
	}
  },
  
  created() {
	  // 获取主页信息
	  this.getHomeContent();
  },
  
  methods: {
	  // 页面跳转
	  goToPage(path, query={}) {
			  this.$router.push({
				path,
				query
			  })
	  },
	  
	  // 获取主页信息
	  getHomeContent() {
		  this.$axios.post('member/index')
		  .then(res => {
			  this.member = res.data;
		  })
		  .catch(err => {})
	  },
	  
	  // 页面跳转，新窗口打开
	  goToPageOpen(path, param={}) {
		  let routeUrl = this.$router.resolve({
			  path: path,
			  query: param
		   });
		   window.open(routeUrl.href, '_blank');
	  },
  }
}
</script>

<style lang="less" scoped>
	.power{
		ul{
			li{
				margin-bottom: .1rem;
				padding-left: .25rem;
				background: url(@/assets/Icons/prohibit.png) no-repeat 0 center/0.14rem;
				&.have{
					background-image: url(@/assets/Icons/allow.png);
				}
			}
		} 
	}
	.personHome{
		margin: 0 -.1rem;
		> div{
			padding: 0 .1rem;
		}
		.rightGuide{
			width: 100%;
			.gList{
				padding: .3rem .2rem;
				ul{
					margin: 0 -.05rem;
					margin-top: -.1rem;
					li{
						width: 20%;
						padding: 0 .05rem;
						margin-top: .1rem;
						.text{
							background: #f2f5fa;
							padding-top: .4rem;
							padding-bottom: .4rem;
							&:hover{
								p{
									color: #2657db;
								}
							}
						}
						figure{
							margin-bottom: .5rem;
							img{
								height: .45rem;
							}
						}
					}
				}
			}
		}
		.psLeftContent{
			width: 100%;
			padding: 0;
			.item{
				width: 29.375%;
				margin-bottom: .2rem;
				&.w100{
					flex: 1 1 auto;
					margin-right: .2rem;
					dd:hover,dd:hover a{
						color: #2657db;
					}
				}
			}
			.table{
				&.ipProduct{
					dl dd{
						span:nth-of-type(1) {
							width: 100%;
						}
					}
				}
				&.history{
					dl dd{
						span:nth-of-type(1) {
							width: calc(100% - 1rem);
						}
						span:last-child {
							width: 2rem;
						}
					}
				}
				dl{
					dt,dd{
						padding: .22rem 0;
					}
					dt{
						background: #f2f5fa;
						border-radius: 5px;
						span:nth-of-type(1) {
							padding-left: .15rem;
						}
					}
					dd{
						&:not(:last-child) {
							border-bottom: solid 1px #eee;
						}
						> span:nth-of-type(1) {
							position: relative;
							padding-left: .2rem;
							&:after{
								content: "";
								position: absolute;
								left: 0;
								top: .1rem;
								width: .04rem;
								height: .04rem;
								background: #2657db;
							}
						}
					}
					span{
						width: 10em;
						&:first-child{
							width: calc(100% - 20em);
						}
						&.tcenter{
							text-align: center;
						}
						.d{
							width: .19rem;
							height: .14rem;
							background: url(@/assets/Icons/look.png) no-repeat center/100% 100%; 
							&:hover{
								background-image: url(@/assets/Icons/lookBlue.png);
							}
						}
					}
				}
			}
		}
		@media (max-width: 1200px) {
			display: block;
			
			>div{
				padding: 0;
			}
			.rightGuide{
				width: 100%;
				.gList ul li{
					width: 33.33%;
					@media (max-width:480px) {
						width: 50%;
						figure{
							margin-bottom: .2rem;
						}
					}
				}
			}
			.psLeftContent{
				width: 100%;
				.item{
					padding: 0;
					width: 100%;
					&.w100{
						margin-right: 0;
					}
				}
			}
		}
		@media (max-width: 640px) {
			padding: .2rem;
		}
	}
</style>
